// extracted by mini-css-extract-plugin
export default {"icon":"SelectProjectMenuItem_icon__qBF9J","projectName":"SelectProjectMenuItem_projectName__rVOFS"};